import { PropTypes } from 'prop-types';
import { FaArrowRight } from 'react-icons/fa6';
import ModelButton from '../modelBtn/modelButton';
import { motion } from 'framer-motion';
import { useState } from 'react';
import ModelView from './modelView';
import { DecodeHtml } from '../../utils/decodeHtml';

const FinCard = ({ status, name, subtitle, description, close, externalLink }) => {
    const [modalOpen, setModalOpen] = useState(false);

    const closed = () => setModalOpen(false);
    const open = () => setModalOpen(true);
    return (
        <div className="w-full sm:w-96  px-4 py-8 bg-white rounded shadow flex-col justify-start items-center gap-4 flex hover:shadow-lg transition-all border">
            {status &&
                <div className={`px-2.5 py-0.5 rounded-xl border ${status.toLowerCase() === "closed" ? "border-red-600 text-red-600" : "border-blue-900 text-blue-900"} justify-center items-center gap-1.5 flex`}>
                    <div className="text-center  text-[8px] sm:text-xs font-medium leading-none uppercase whitespace-nowrap">{status}</div>
                </div>
            }
            <div className="self-stretch flex-col h-full flex-1 justify-between items-center gap-4 flex">
                <h1 className="self-stretch text-center text-slate-900 text-2xl px-5 font-bold  ">{name}</h1>
                <div className='self-stretch flex flex-1 items-center justify-center text-center flex-col'>
                    {subtitle && <span className=" text-sky-950 text-opacity-70 text-base font-normal leading-normal">{DecodeHtml({html:subtitle})}</span>}
                    {close && <span className="self-stretch  text-center text-sky-950 text-opacity-70 text-base font-bold leading-normal">Close: {close}</span>}
                </div>
                {
                    externalLink ? <a href={externalLink} target="_blank" rel="noreferrer" className="px-8 py-4 bg-red-800 rounded justify-center items-center gap-4 flex">
                        <span className="text-white text-base font-bold capitalize underline underline-offset-4 flex items-center gap-3">Learn More <FaArrowRight /></span>
                    </a>
                        :
                        description == "" ?
                            <button
                                className="px-8 py-4 bg-red-800 rounded justify-center items-center gap-4 flex"
                            >
                                <span className="text-white text-base font-bold capitalize flex items-center gap-3">Apply Now <FaArrowRight /></span>
                            </button>
                            :
                            <>
                                <div>
                                    <motion.button
                                        whileHover={{ scale: 1.05 }}
                                        whileTap={{ scale: 0.9 }}
                                        className="px-8 py-4 bg-red-800 rounded justify-center items-center gap-4 flex"
                                        onClick={() => (modalOpen ? closed() : open())}
                                    >
                                        <span className="text-white text-base font-bold capitalize flex items-center gap-3">Apply Now <FaArrowRight /></span>
                                    </motion.button>
                                </div>

                                <ModelButton modalOpen={modalOpen} close={closed}>
                                    <ModelView title={name} description={description} />
                                </ModelButton>
                            </>

                }

            </div>
        </div >
    )
}
FinCard.propTypes = {
    status: PropTypes.string,
    name: PropTypes.string,
    subtitle: PropTypes.string,
    description: PropTypes.string,
    externalLink: PropTypes.string,
    close: PropTypes.string,
    children: PropTypes.node
}
export default FinCard